"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryConstant = exports.HttpMethod = exports.HttpStatusCode = void 0;
/**
 * @author Siglud <Siglud@gmail.com>
 */
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
    HttpStatusCode[HttpStatusCode["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatusCode[HttpStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatusCode[HttpStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatusCode[HttpStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatusCode[HttpStatusCode["NOTFOUND"] = 404] = "NOTFOUND";
    HttpStatusCode[HttpStatusCode["TOOMANYREQS"] = 429] = "TOOMANYREQS";
    HttpStatusCode[HttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(HttpStatusCode || (exports.HttpStatusCode = HttpStatusCode = {}));
class HttpMethod {
    static POST = "POST";
    static GET = "GET";
    static DELETE = "DELETE";
    static PATCH = "PATCH";
}
exports.HttpMethod = HttpMethod;
class TelemetryConstant {
    // the component name of the deployment life cycle
    static DEPLOY_COMPONENT_NAME = "deploy";
    // the component name of the provision life cycle
    static PROVISION_COMPONENT_NAME = "provision";
    // the script component name
    static SCRIPT_COMPONENT = "script";
    // the component name of the deployment to SWA script
    static DEPLOY_TO_SWA_COMPONENT = "deploy_to_swa";
}
exports.TelemetryConstant = TelemetryConstant;
//# sourceMappingURL=commonConstant.js.map